// DEMO stub — Firebase is neutralized for the demo build.
// The real Firebase SDK is intentionally NOT imported here so that no network
// calls or app initialization happen. All methods resolve as no-ops.
// authSlice still imports this service (e.g. for signOut); keeping the same
// shape means the redux slice does not need to change.

const noop = async () => ({})

const FirebaseService = {
	signInEmailRequest: noop,
	signOutRequest: noop,
	signInGoogleRequest: noop,
	signInFacebookRequest: noop,
	signUpEmailRequest: noop,
}

export default FirebaseService
